// extracted by mini-css-extract-plugin
export default {"root":"CheckTowModal_root__zTzPX","modalContent":"CheckTowModal_modalContent__Md-R-","coverageText":"CheckTowModal_coverageText__upBmP","modalIcon":"CheckTowModal_modalIcon__qm0z9"};